<template><!-- svgo-optimised -->
<svg class="icon icon__loading" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-labelledby="loading" role="img"><title id="loading">Loading</title><path d="M0 0h24v24H0z"/></svg></template>